import React from "react";
import { Events } from "../components/index";
const EventsPage = () => {
  return (
    <>
      <div className="App">
        <Events />
      </div>
    </>
  );
};

export default EventsPage;
